import React from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const CustomToolbar = (p) => {
    const classes = p.classes;

    return (
        <React.Fragment>
            <Tooltip title={"Adiconar Fornecedor ao grupo"}>
                <IconButton className={classes.iconButton} onClick={p.handleAdicionar}>
                    <i className="material-icons">edit</i>
                </IconButton>
            </Tooltip>
        </React.Fragment>
    );
};

export default withStyles(
    (theme) => ({
        iconButton: {
            "&:hover": {
                color: theme.palette.primary.main,
            },
        },
    }),
    { name: "CustomToolbar" }
)(CustomToolbar);
